import BarChart from '../../../common/components/Charts/BarChart/BarChart';

import styles from './Overview.module.scss';

const { whiteText, blueLabelColors, bluebackgroundDark } = styles;

const UserStatusBarChart = () => {
	const options = {
		axis: 'x',
		categoryPercentage: 0.4, // here
		barPercentage: 1,
		maintainAspectRatio: false,
		scales: {
			x: {
				display: false,
				grid: {
					display: false,
					drawOnChartArea: false,
					color: whiteText,
				},
				ticks: {
					display: false,
				},
			},
			y: {
				display: false,
				beginAtZero: true,
				grid: {
					display: false,
					drawOnChartArea: false,
					color: whiteText,
				},
				ticks: {
					display: false,
				},
			},
		},
		elements: {
			bar: {
				borderWidth: 1,
			},
		},
		responsive: true,
		plugins: {
			legend: {
				display: false,
			},
			title: {
				display: false,
				text: 'Active and InActive Users Chart',
			},
			tooltip: {
				enabled: false, // <-- this option disables tooltips
			},
		},
	};

	const labels = ['0', '1', '2', '3', '4', '5', '6'];

	const data = {
		labels,
		datasets: [
			{
				label: 'Active',
				data: [1, 10, 5, 7, 12, 10, 12],
				borderColor: bluebackgroundDark,
				backgroundColor: bluebackgroundDark,
				maxBarThickness: 14,
			},
			{
				label: 'InActive',
				data: [2, 10, 3, 6, 9, 10, 4],
				borderColor: blueLabelColors,
				backgroundColor: blueLabelColors,
				maxBarThickness: 14,
			},
		],
	};
	return (
		<div className={styles['overview-user-barchart']}>
			<BarChart options={options} data={data} />
		</div>
	);
};

export default UserStatusBarChart;
